import { ArtButton } from "components/button";
import { TextInput } from "components/input/text-input";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setAuthInfos, clearAuthInfos } from "reducer/wallet.slice";
import {
    Checkbox,
    Modal,
} from "semantic-ui-react";
import { api, ui } from "services";
import { PasswordInput } from "../../components/input/password-input";

export default function AddFarmer({ open, onClose }: any) {
    const [password, setPassword] = useState("");
    const [username, setUsername] = useState("");
    const [loading, setLoading] = useState(false);
    const [textErr, setTextErr] = useState("");
    const [check2FA, setCheck2FA] = useState(false);
    const [pwErr, setPwErr] = useState("");
    const { t } = useTranslation();
    const dispatch = useDispatch();
    function close() {
        resetState();
        onClose();
    }
    const onSubmit = () => {
        setLoading(true);
        api.createFarmerAccount(username, password, check2FA).then(data => {
            close();
            api.getAuthInfos().then(data => {
                dispatch(clearAuthInfos())
                dispatch(setAuthInfos(data));
            })
            setLoading(false);
        }).catch(err => {
            setLoading(false);
            ui.alertFailed("", t(err.message))
        })
    }
    const resetState = () => {
        setPassword("");
        setUsername("");
    }
    return (
        <Modal
            size="small"
            open={open}
            style={{ width: "unset" }}
        >
            <div
                className="max-w-[564px] w-screen"
            >
                <div className="max-w-[564px] w-screen bg-black-secondary pb-8">
                    <div>
                        <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
                            Add alternate login ID
                        </div>
                        <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-9" />

                        <div className="w-11/12 mx-auto">
                            <TextInput
                                type="username"
                                submit={onSubmit}
                                setErr={setTextErr}
                                fieldName="Username" value={username} setValue={setUsername} />
                            <PasswordInput
                                submit={onSubmit}
                                setErr={setPwErr}
                                fieldName="New password" setPassword={setPassword} password={password} />

                            {/* <div className="flex mt-2">
                                <Checkbox
                                    toggle
                                    checked={check2FA}
                                    onChange={(e) => {
                                        setCheck2FA(!check2FA);
                                    }}
                                    className="w-6 h-6"
                                />
                                <span className="text-white ml-2 mt-1">
                                    Required enable second authenticator factor
                                </span>
                            </div> */}
                        </div>

                        <div className={`flex w-[360px] gap-4 mt-6 text-center items-center mx-auto`}>
                            <ArtButton color="red"
                                onClick={() => {
                                    close();
                                    resetState();
                                }}
                            >
                                <div className="text-white font-semibold">
                                    Cancel
                                </div>
                            </ArtButton>
                            <ArtButton color="yellow"
                                onClick={onSubmit}
                                disabled={!!textErr || !!pwErr}
                                loading={loading}
                            >
                                <div className="text-white font-semibold">
                                    Save
                                </div>
                            </ArtButton>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
